import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { userService } from '@/services/UserService'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose }) {


const logo = ref<HTMLImageElement | null>(null)
const isLoggedIn = computed(() => userService.isLoggedIn())
const isAdmin = computed(() => userService.user?.isAdmin || false)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const version = process.env.VUE_APP_VERSION || '0.0.0-local'

// eslint-disable-next-line no-undef
expose({ isLoggedIn, isAdmin })

onMounted(async() => {
  document.body.classList.add('dark');
  if (logo.value) {
    // eslint-disable-next-line no-undef
    await ui("theme", logo.value.src)
  }
});


const __returned__ = { logo, isLoggedIn, isAdmin, version, computed, onMounted, ref, userService }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})